import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import SelectInput from "../../custom/components/Select-Input/SelectInput";
import TextInput from "../../custom/components/Text-Input/TextInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, outwardFormData } from "./OutwardFile";
import {
  dropdownData,
  formatNumber,
  getRecords,
  saveRecords,
  uploadFile,
} from "../../services/api.service";
import { toast } from "react-toastify";
import { TransactionalValidation } from "../../custom/validations/TransactionalValidation";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput";
import NumberInput from "./../../custom/components/Number-Input/NumberInput";
import Asterisks from "../../custom/components/Asterisks/Asterisks";

const OutwardCreate = () => {
  const { id } = useParams;
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
    typeSelectOptions,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(outwardFormData());
  const [formErrors, setFormErrors] = useState({});
  const [customerSelect, setCustomerSelect] = useState("");
  const [warehouseSelect, setWarehouseSelect] = useState("");
  const [warehouseSelectOptions, setWarehouseSelectOptions] = useState([]);
  const [userSelect, setUserSelect] = useState("");
  const [userSelectOptions, setUserSelectOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [groupedItems, setGroupedItems] = useState({});
  const [typeSelect, setTypeSelect] = useState("");
  const [filteredItems, setFilteredItems] = useState(
    formData?.inputData?.outward_items || []
  );
  const [filteredItemsdropdownData, setFilteredItemsDropdownData] = useState(
    []
  );
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    getCustomerData(projectId);
    getWarehouseDropData();
    getUserMasterDropData();
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      inputRef.current &&
      !inputRef.current.contains(event.target)
    ) {
      setIsDropdownVisible(false);
    }
  };
  const getCustomerData = async (Id) => {
    try {
      let payload = {
        modelName: "projects",
        whereCondition: {
          is_active: true,
          id: Id,
        },
        relations: [
          {
            module: "user_masters",
            moduleAs: "customer",
          },
        ],
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.data && responseData.data.length > 0) {
        setCustomerSelect(
          `${responseData?.data[0]?.customer?.first_name} ${responseData?.data[0]?.customer?.last_name}`
        );
        const customerId = responseData?.data[0]?.customer_id;
        setFormData((prevState) => ({
          ...prevState,
          inputData: {
            ...prevState.inputData,
            customer_id: customerId,
            project_id: Id,
          },
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getWarehouseDropData = async () => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    try {
      let payload = {
        modelName: "warehouse_masters",
        whereCondition: {
          is_active: true,
          project_id: projectId,
        },
      };
      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "warehouse_name"
        );
        setWarehouseSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getUserMasterDropData = async () => {
    try {
      let payload = {
        modelName: "user_masters",
        whereCondition: {
          is_active: true,
        },
        relations: [
          {
            module: "project_access",
            moduleAs: "project_access",
            required: true,
            whereCondition: {
              project_id: JSON.parse(localStorage.getItem("projectID")),
              access: true,
            },
          },
        ],
      };
      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "first_name"
        );
        setUserSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const getWarehouseStockTableData = async (Id) => {
    try {
      const projectId = JSON.parse(localStorage.getItem("projectID"));
      let payload = {
        modifyResponse: true,
        getAvailableProvisionQty: true,
        outwardType: formData?.inputData?.type,
        modelName: "stocks",
        whereCondition: {
          warehouse_id: Id,
          project_id: projectId,
        },
        relations: [
          {
            module: "item_masters",
            moduleAs: "makeItem",
            subModule: "uom_masters",
            subModuleAs: "uom",
          },
          {
            module: "item_masters",
            moduleAs: "buyItem",
            subModule: "uom_masters",
            subModuleAs: "uom",
          },
        ],
      };

      const responseData = await getRecords(payload, "/getRecords");

      if (responseData?.code == 1 && responseData?.data) {
        // Filter data based on the type
        let filteredData = responseData.data;
        if (
          formData?.inputData?.type === "Outward" ||
          formData?.inputData?.type === "MRB"
        ) {
          // Only include items with stock_qty > 0
          filteredData = filteredData.filter((data) => data?.stock_qty > 0);
        } else if (formData?.inputData?.type === "Scrab") {
          // Only include items with mrb_qty > 0
          // filteredData = filteredData.filter((data) => data?.mrb_qty > 0);
          filteredData = filteredData.filter((data) => data?.mrb_qty > 0);
        }

        // Map the filtered data
        const outwardsItems = filteredData?.map((item) => ({
          item_id: item?.item_id,
          buy_item_id: item?.buy_item_id,
          item_code: item?.makeItem?.item_code,
          buy_item_code: item?.buyItem?.item_code,
          description: item?.buyItem?.description,
          uom: item.buyItem.uom?.uom_name,
          make_item_desc: item?.makeItem?.description,
          make_item_uom: item.makeItem?.uom?.uom_name,
          stock_qty: item?.stock_qty,
          mrb_qty: item?.mrb_qty,
          is_make_item: item?.is_make_item,
          outward_qty: null,
          scrab_qty: null,
          mrb_qnty: null,
          is_active: true,
          type: item.is_make_item ? 1 : 2,
          id: item.id,
          is_show: false,
          make_buy_name: item?.is_make_item
            ? item?.buyItem?.item_code + " (" + item?.makeItem?.item_code + ")"
            : item?.buyItem?.item_code,
        }));

        // Update form data and state
        setFormData((prevState) => ({
          ...prevState,
          inputData: {
            ...prevState.inputData,
            warehouse_id: Id,
            outward_items: outwardsItems,
          },
        }));
        setFilteredItems(outwardsItems);
        setFilteredItemsDropdownData(outwardsItems);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = TransactionalValidation(validationType, {
      [name]: value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? true : false) : value,
      },
    }));
  };

  const handleWarehouseSelect = (options) => {
    const selectedValue = options ? options.value : null;
    const fieldError = TransactionalValidation(validationType, {
      warehouse_id: selectedValue,
    });
    const updatedErrors = { ...formErrors };
    if (updatedErrors?.outward_items) {
      delete updatedErrors.outward_items;
    }

    setWarehouseSelect(options);
    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        outward_items: [],
      },
    }));
    setGroupedItems({});
    setFormErrors({
      ...updatedErrors,
      warehouse_id: fieldError?.warehouse_id || null,
    });

    getWarehouseStockTableData(selectedValue);
  };

  const handleUserSelect = (options) => {
    const selectedValue = options ? options.value : null;

    const fieldError = TransactionalValidation(validationType, {
      contractor_id: selectedValue,
    });

    setUserSelect(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      contractor_id: fieldError?.contractor_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        contractor_id: selectedValue,
      },
    }));
  };

  const handleTypeSelect = (options) => {
    const selectedValue = options ? options.value : null;

    const fieldError = TransactionalValidation(validationType, {
      type: selectedValue,
    });

    setTypeSelect(options);
    setUserSelect([]);
    setWarehouseSelect([]);
    setGroupedItems([]);
    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      // Ensure outward_items exists before modifying errors
      if (updatedErrors.outward_items) {
        Object.keys(updatedErrors.outward_items).forEach((key) => {
          updatedErrors.outward_items[key] = {
            ...updatedErrors.outward_items[key],
            outward_qty:
              selectedValue === "Outward"
                ? updatedErrors.outward_items[key]?.outward_qty
                : "",
            mrb_qnty:
              selectedValue === "MRB"
                ? updatedErrors.outward_items[key]?.mrb_qnty
                : "",
            scrab_qty:
              selectedValue === "Scrab"
                ? updatedErrors.outward_items[key]?.scrab_qty
                : "",
          };
        });
      }

      return {
        ...updatedErrors,
        type: fieldError?.type || "",
      };
    });

    setFormData((prevState) => {
      const updatedItems = prevState.inputData.outward_items?.map((item) => ({
        ...item,
        outward_qty: selectedValue == "Outward" ? item.outward_qty : "",
        mrb_qnty: selectedValue == "MRB" ? item.mrb_qnty : "",
        scrab_qty: selectedValue == "Scab" ? item.scrab_qty : "",
      }));

      return {
        ...prevState,
        inputData: {
          ...prevState.inputData,
          type: selectedValue,
          outward_items: updatedItems,
        },
      };
    });
  };

  const handleItemDetailInputChange = (e, itemCode, field) => {
    const { name, value } = e.target;
    const quantityValue = value;

    const currentItemIndex = formData?.inputData?.outward_items.findIndex(
      (item) => item.id == itemCode
    );
    if (currentItemIndex === -1) return;

    const currentItem = formData?.inputData?.outward_items[currentItemIndex];
    const isActive = currentItem?.is_active;

    const stockField =
      formData.inputData.type == "Outward"
        ? "stock_qty"
        : formData.inputData.type == "MRB"
        ? "stock_qty"
        : formData.inputData.type == "Scrab"
        ? "mrb_qty"
        : "stock_qty";

    const errorMessage =
      isActive && quantityValue === 0
        ? `${name.replace(/_/g, " ")} can't be zero.`
        : isActive && quantityValue > currentItem?.[stockField]
        ? `${name.replace(
            /_/g,
            " "
          )} should not be greater than ${stockField.replace(/_/g, " ")}.`
        : "";

    setFormErrors((prev) => ({
      ...prev,
      outward_items: {
        ...prev.outward_items,
        [itemCode]: isActive
          ? { ...prev.outward_items?.[itemCode], [name]: errorMessage }
          : prev.outward_items?.[itemCode],
      },
    }));

    setFormData((prevState) => {
      const updatedDetails = [...prevState?.inputData?.outward_items];
      const currentItem = updatedDetails[currentItemIndex];

      if (!currentItem) return prevState;

      updatedDetails[currentItemIndex] = {
        ...currentItem,
        [name]: quantityValue,
      };

      return {
        ...prevState,
        inputData: {
          ...prevState.inputData,
          outward_items: updatedDetails,
        },
      };
    });

    setGroupedItems((prevGroupedItems) => {
      const updatedGroupedItems = { ...prevGroupedItems };

      Object.entries(updatedGroupedItems).forEach(([key, group]) => {
        group.buyItems = group.buyItems.map((item) =>
          item.id === itemCode ? { ...item, [field]: value } : item
        );
      });

      return updatedGroupedItems;
    });
  };

  // const handleItemDetailInputChange = (e, itemCode, field) => {
  //   const { name, value } = e.target;
  //   const quantityValue = value.trim() !== "" ? parseInt(value, 10) : 0; // Ensure it's a valid number

  //   const currentItemIndex = formData?.inputData?.outward_items.findIndex(
  //     (item) => item.id == itemCode
  //   );
  //   if (currentItemIndex === -1) return;

  //   const currentItem = formData?.inputData?.outward_items[currentItemIndex];
  //   const isActive = currentItem?.is_active;

  //   const stockField =
  //     formData.inputData.type === "Scrab" ? "mrb_qty" : "stock_qty"; // Simplified logic

  //   const errorMessage =
  //     isActive && quantityValue === 0
  //       ? `${name.replace(/_/g, " ")} can't be zero.`
  //       : isActive && quantityValue > currentItem?.[stockField]
  //       ? `${name.replace(
  //           /_/g,
  //           " "
  //         )} should not be greater than ${stockField.replace(/_/g, " ")}.`
  //       : "";

  //   setFormErrors((prev) => ({
  //     ...prev,
  //     outward_items: {
  //       ...prev.outward_items,
  //       [itemCode]: isActive
  //         ? { ...prev.outward_items?.[itemCode], [name]: errorMessage }
  //         : prev.outward_items?.[itemCode],
  //     },
  //   }));

  //   setFormData((prevState) => {
  //     const updatedDetails = [...prevState?.inputData?.outward_items];
  //     updatedDetails[currentItemIndex] = {
  //       ...updatedDetails[currentItemIndex],
  //       [name]: quantityValue,
  //     };

  //     return {
  //       ...prevState,
  //       inputData: {
  //         ...prevState.inputData,
  //         outward_items: updatedDetails,
  //       },
  //     };
  //   });

  //   setGroupedItems((prevGroupedItems) => {
  //     const updatedGroupedItems = { ...prevGroupedItems };

  //     Object.entries(updatedGroupedItems).forEach(([key, group]) => {
  //       group.buyItems = group.buyItems.map((item) =>
  //         item.id === itemCode ? { ...item, [field]: quantityValue } : item
  //       );
  //     });

  //     return updatedGroupedItems;
  //   });
  // };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const validationErrors = TransactionalValidation(
        validationType,
        formData.inputData
      );

      if (Object.keys(validationErrors).length > 0) {
        setFormErrors(validationErrors);
        return;
      }

      const updatedFormData = { ...formData };

      const quantityField =
        formData.inputData.type === "Outward"
          ? "outward_qty"
          : formData.inputData.type === "MRB"
          ? "mrb_qnty"
          : formData.inputData.type === "Scrab"
          ? "scrab_qty"
          : "outward_qty";

      const allItemsInactive = Object.values(groupedItems).every(
        (group) =>
          !group.makeItem.is_show &&
          group.buyItems.every((item) => !item.is_show)
      );

      if (allItemsInactive) {
        toast.error("Please add item first.");
        return;
      }
      const hasActiveOutwardItem =
        updatedFormData?.inputData?.outward_items?.some(
          (item) => Number(item?.[quantityField]) > 0
        );

      if (!hasActiveOutwardItem) {
        toast.error(
          `Please enter a ${quantityField.replace(
            "_",
            " "
          )} greater than 0 for at least one item.`
        );
        return;
      }

      const additionalErrors = {};
      updatedFormData?.inputData?.outward_items?.forEach((row) => {
        if (row?.is_active === true) {
          const { type } = formData.inputData;

          const quantityField =
            type === "Outward"
              ? "outward_qty"
              : type === "MRB"
              ? "mrb_qnty"
              : type === "Scrab"
              ? "scrab_qty"
              : "outward_qty";

          const stockField =
            type == "Outward"
              ? "stock_qty"
              : type === "MRB"
              ? "stock_qty"
              : type == "Scrab"
              ? "mrb_qty"
              : "stock_qty";

          const fieldValue = row[quantityField]?.toString();

          if (fieldValue && parseFloat(fieldValue) > row?.[stockField]) {
            additionalErrors.outward_items = {
              ...additionalErrors.outward_items,
              [row.id]: {
                ...additionalErrors.outward_items?.[row.id],
                [quantityField]: `${quantityField.replace(
                  /_/g,
                  " "
                )} should not be greater than ${stockField.replace(
                  /_/g,
                  " "
                )}.`,
              },
            };
          }
        }
      });

      if (Object.keys(additionalErrors).length > 0) {
        setFormErrors(additionalErrors);
        return;
      }
      let transformedInputData = {
        project_id: JSON.parse(localStorage.getItem("projectID")) || null,
        warehouse_id: updatedFormData?.inputData?.warehouse_id || null,
        customer_id: updatedFormData?.inputData?.customer_id || null,
        contractor_id: updatedFormData?.inputData?.contractor_id || null,
        outward_date: updatedFormData?.inputData?.outward_date || null,
        vehical_no: updatedFormData?.inputData?.vehical_no || null,
        remark: updatedFormData?.inputData?.remark || null,
        type: updatedFormData.inputData.type || null,
        created_by: updatedFormData?.inputData?.created_by || 1,
        is_active: true,

        outward_items: updatedFormData?.inputData?.outward_items
          ?.filter((item) => {
            const quantityField =
              formData.inputData.type === "Outward"
                ? "outward_qty"
                : formData.inputData.type === "MRB"
                ? "mrb_qnty"
                : formData.inputData.type === "Scrab"
                ? "scrab_qty"
                : "outward_qty";

            return (
              item?.is_active &&
              !isNaN(item[quantityField]) &&
              item[quantityField] > 0
            );
          })
          ?.map((item) => {
            return {
              item_id: item?.item_id,
              buy_item_id: item?.buy_item_id,
              outward_qty: parseFloat(
                formData.inputData.type === "Outward"
                  ? item.outward_qty
                  : formData.inputData.type === "MRB"
                  ? item.mrb_qnty
                  : formData.inputData.type === "Scrab"
                  ? item.scrab_qty
                  : item.outward_qty
              ),

              is_make_item: item.is_make_item,
              is_active: item?.is_active,
              stock_qty: parseFloat(
                formData.inputData.type === "Outward"
                  ? item.stock_qty
                  : formData.inputData.type === "MRB"
                  ? item.stock_qty
                  : formData.inputData.type === "Scrab"
                  ? item.mrb_qty
                  : item.stock_qty
              ),
            };
          }),
      };

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));

      const updatedInputData = {
        ...transformedInputData,
        created_by: userDetails
          ? userDetails?.id || 1
          : updatedFormData?.inputData?.created_by,
      };

      const payload = {
        id: id,
        modelName: initialPayload?.modelName,
        relation: initialPayload?.relation,
        inputData: updatedInputData,
      };

      setLoadingData(true);
      const responseData = await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code == 1) {
        toast.success(`${headerName} saved successfully!`);
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("err", error);
    } finally {
      setLoadingData(false);
    }
  };

  const FloatValue = (value) => {
    return parseFloat(value);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value === "") {
      setFilteredItemsDropdownData(
        formData?.inputData?.outward_items?.filter(
          (item) => item.is_show === false
        )
      );
    } else {
      const filtered = formData?.inputData?.outward_items?.filter(
        (item) =>
          (item?.buy_item_code?.toLowerCase().includes(value.toLowerCase()) ||
            item?.item_code?.toLowerCase().includes(value.toLowerCase())) &&
          item.is_show === false
      );

      setFilteredItemsDropdownData(filtered);
    }
  };

  const handleItemSelect = (selectedGroup) => {
    setFilteredItemsDropdownData((prev) =>
      prev.map((item) =>
        item.id === selectedGroup.id ? { ...item, is_show: true } : item
      )
    );

    setGroupedItems((prevGroupedItems) => {
      const updatedGroupedItems = { ...prevGroupedItems };

      if (!selectedGroup) return prevGroupedItems;

      const groupKey = selectedGroup.item_code;

      if (!updatedGroupedItems[groupKey]) return prevGroupedItems;

      const group = updatedGroupedItems[groupKey];

      const selectedBuyItem = group.buyItems.find(
        (item) => item.id === selectedGroup.id
      );

      if (selectedBuyItem && selectedBuyItem.is_show) {
        toast.error(
          `The item "${selectedGroup.buy_item_code}" is already added.`
        );
        return prevGroupedItems;
      }

      if (group.makeItem) {
        group.makeItem = { ...group.makeItem, is_show: true };
      }

      group.buyItems = group.buyItems.map((item) =>
        item.id === selectedGroup.id ? { ...item, is_show: true } : item
      );

      toast.success(
        `The item "${selectedGroup.buy_item_code}" added successfully.`
      );

      return updatedGroupedItems;
    });
    setFormData((prevFormData) => ({
      ...prevFormData,
      inputData: {
        ...prevFormData.inputData,

        outward_items: prevFormData.inputData.outward_items.map((item) =>
          item.id === selectedGroup.id ? { ...item, is_show: true } : item
        ),
      },
    }));
    setIsDropdownVisible(false);
  };

  const handleRemoveItemDetail = (group, itemToRemove) => {
    const quantityField =
      formData.inputData.type === "Outward"
        ? "outward_qty"
        : formData.inputData.type === "MRB"
        ? "mrb_qnty"
        : formData.inputData.type === "Scrab"
        ? "scrab_qty"
        : "outward_qty";

    setGroupedItems((prevItems) => {
      const updatedItems = { ...prevItems };

      if (updatedItems[group.makeItem.item_code]) {
        const updatedGroup = updatedItems[group.makeItem.item_code];

        if (updatedGroup.makeItem.unique_id === itemToRemove.unique_id) {
          updatedGroup.makeItem = { ...updatedGroup.makeItem, is_show: false };
          updatedGroup.buyItems = updatedGroup.buyItems.map((item) => ({
            ...item,
            is_show: false,
            [quantityField]: "",
          }));
          setFilteredItemsDropdownData((prev) =>
            prev.map((item) =>
              item.item_id === itemToRemove.item_id
                ? { ...item, is_show: false }
                : item
            )
          );
        } else {
          updatedGroup.buyItems = updatedGroup.buyItems.map((item) =>
            item.id === itemToRemove.id
              ? { ...item, is_show: false, [quantityField]: "" }
              : item
          );

          const remainingVisibleBuyItems = updatedGroup.buyItems.filter(
            (item) => item.is_show
          );

          if (remainingVisibleBuyItems.length === 0) {
            updatedGroup.makeItem = {
              ...updatedGroup.makeItem,
              is_show: false,
              [quantityField]: "",
            };
          }
          setFilteredItemsDropdownData((prev) =>
            prev.map((item) =>
              item.id === itemToRemove.id ? { ...item, is_show: false } : item
            )
          );
        }
      }

      return updatedItems;
    });

    setFilteredItemsDropdownData((prev) =>
      prev.map((item) =>
        item.id == itemToRemove.id ? { ...item, is_show: false } : item
      )
    );

    setFormData((prevState) => {
      if (!prevState?.inputData?.outward_items) return prevState;

      const updatedDetails = [...prevState.inputData.outward_items];

      const currentItemIndex = updatedDetails.findIndex(
        (item) => item.id === itemToRemove.id
      );

      if (currentItemIndex === -1) return prevState;

      updatedDetails[currentItemIndex] = {
        ...updatedDetails[currentItemIndex],
        [quantityField]: "",
        is_show: false,
      };

      return {
        ...prevState,
        inputData: {
          ...prevState.inputData,
          outward_items: updatedDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      if (!prevErrors?.outward_items) return prevErrors;

      const updatedErrors = { ...prevErrors };

      if (itemToRemove.unique_id === group.makeItem.unique_id) {
        group.buyItems.forEach((buyItem) => {
          delete updatedErrors.outward_items?.[buyItem.id];
        });
      } else {
        delete updatedErrors.outward_items?.[itemToRemove.id];
      }

      return updatedErrors;
    });
  };
  useEffect(() => {
    if (!filteredItems || filteredItems.length === 0) return;

    const grouped = filteredItems.reduce((acc, item) => {
      if (!acc[item.item_code]) {
        acc[item.item_code] = {
          makeItem: { ...item, unique_id: `${item.item_code}-${item.id}` },
          buyItems: [],
        };
      }

      if (item.buy_item_code) {
        acc[item.item_code].buyItems.push({
          ...item,
          unique_id: `${item.buy_item_code}-${item.id}`,
        });
      }

      return acc;
    }, {});

    setGroupedItems(grouped);
  }, [filteredItems]);

  let serialNumber = 1;

  return (
    <CustomForm
      title={"CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="4" className="mt-3">
          <SelectInput
            label="Type"
            value={typeSelect || typeSelectOptions[0]}
            options={typeSelectOptions}
            onSelect={(selected) => handleTypeSelect(selected)}
            placeholder="Select Type"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.type}
          />
        </Col>
        <Col md="4" className="mt-3">
          <SelectInput
            label="Warehouse"
            value={warehouseSelect}
            options={warehouseSelectOptions}
            onSelect={(selected) => handleWarehouseSelect(selected)}
            placeholder="Select warehouse"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.warehouse_id}
          />
        </Col>

        <Col md="4" className="mt-3">
          <SelectInput
            label={formData.inputData.type === "Scrab" ? "Assigned To" : "User"}
            value={userSelect}
            options={userSelectOptions}
            onSelect={(selected) => handleUserSelect(selected)}
            placeholder={
              formData.inputData.type === "Scrab"
                ? "Select assigned To"
                : "Select user"
            }
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.contractor_id}
          />
        </Col>

        <Col md="4" className="mt-3">
          <TextInput
            label="Vehical no"
            name="vehical_no"
            value={formData?.inputData?.vehical_no}
            onChange={onInputChange}
            placeholder="Vehical no"
            inputClassName="form-control"
            labelClassName="form-label"
            autocomplete={"off"}
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col
          style={{
            marginBottom: "0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "3px",
          }}
        >
          <h6
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#333",
              backgroundColor: "#f8f9fa",
              padding: "10px 20px",
              borderRadius: "8px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              display: "inline-block",
              margin: "0px",
            }}
          >
            Item Details
          </h6>

          <div>
            <div className="app-search d-flex d-lg-inline mt-0 w-25">
              <div className="position-relative">
                <input
                  ref={inputRef}
                  type="text"
                  className="form-control ps-5"
                  placeholder="Add item code..."
                  value={inputValue}
                  onChange={handleInputChange}
                  onFocus={() => {
                    setIsDropdownVisible(true);
                  }}
                  style={{
                    width: "13rem",
                    padding: "8px 15px",
                    borderRadius: "8px",
                    borderColor: "#D2D2D2",
                    outline: "none",
                    transition: "all 0.3s ease",
                    boxShadow: "none",
                    marginRight: "0.5rem",
                  }}
                />
                <span className="ri-search-line"></span>
              </div>
            </div>

            {isDropdownVisible && (
              <div
                ref={dropdownRef}
                style={{
                  width: "13rem",
                  maxHeight: "150px",
                  overflowY: "auto",
                  border: "1px solid #D2D2D2",
                  borderRadius: "8px",
                  marginTop: "5px",
                  position: "absolute",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  zIndex: "1000",
                }}
              >
                {filteredItemsdropdownData &&
                filteredItemsdropdownData?.filter(
                  (item) => item.is_show === false
                )?.length > 0 ? (
                  filteredItemsdropdownData
                    ?.filter((item) => item.is_show === false)
                    ?.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => handleItemSelect(item)}
                        style={{
                          padding: "8px 15px",
                          cursor: "pointer",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f0f0f0")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        {item.make_buy_name}
                      </div>
                    ))
                ) : (
                  <div
                    style={{
                      padding: "8px 15px",
                      cursor: "pointer",
                      borderBottom: "1px solid #f0f0f0",
                      textAlign: "center",
                      color: "gray",
                    }}
                  >
                    No Data..
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
        <div
          className="table mt-2"
          style={{
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: "500px",
            width: "100%",
            scrollBehavior: "smooth",
            scrollbarWidth: "thin",
            msOverflowStyle: "none",
            zIndex: 0,
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 1,
              }}
            >
              <tr style={{ borderBottom: "1px solid black" }}>
                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                <th style={{ whiteSpace: "nowrap" }}>Item Code</th>

                <th style={{ whiteSpace: "nowrap" }}>Item Description</th>
                <th style={{ whiteSpace: "nowrap" }}>UOM</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  {formData.inputData.type === "Scrab"
                    ? "MRB QTY"
                    : "Stock QTY"}
                </th>

                <th style={{ whiteSpace: "nowrap" }}>
                  {formData.inputData.type === "Outward"
                    ? "Outward QTY"
                    : formData.inputData.type === "MRB"
                    ? "MRB QTY"
                    : formData.inputData.type === "Scrab"
                    ? "Scrap QTY"
                    : "Outward QTY"}

                  <Asterisks asterisk={true} />
                </th>

                <th style={{ whiteSpace: "nowrap" }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {Object.values(groupedItems).length === 0 ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>
                    No data available.
                  </td>
                </tr>
              ) : Object.values(groupedItems).every(
                  (group) =>
                    !group.makeItem.is_show &&
                    group.buyItems.every((item) => !item.is_show)
                ) ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>
                    Please add item from dropdown.
                  </td>
                </tr>
              ) : (
                Object.values(groupedItems)?.map((group, index) => (
                  <React.Fragment key={group.makeItem.unique_id}>
                    {group?.makeItem?.type == 1 && group?.makeItem?.is_show && (
                      <tr
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#f0f8ff",
                        }}
                      >
                        <td>{serialNumber++}</td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                            }}
                            title={group?.makeItem?.item_code || "N/A"}
                          >
                            {group?.makeItem?.item_code || "N/A"}
                          </div>
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                        >
                          {" "}
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                            }}
                            title={group?.makeItem?.make_item_desc || "N/A"}
                          >
                            {group?.makeItem?.make_item_desc || "N/A"}
                          </div>
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "100px",
                          }}
                        >
                          {" "}
                          {group?.makeItem?.make_item_uom || "N/A"}
                        </td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td
                          onClick={() =>
                            handleRemoveItemDetail(group, group.makeItem)
                          }
                        >
                          <Link className="text-danger">
                            <i className="mdi mdi-trash-can font-size-20"></i>
                          </Link>
                        </td>{" "}
                      </tr>
                    )}

                    {group?.buyItems
                      ?.filter((item) => item.is_show && item.type == 1)
                      ?.map((row, subIndex) => (
                        <tr
                          key={row.unique_id}
                          style={{ borderBottom: "1px solid #ccc" }}
                        >
                          <td>{`${serialNumber - 1}.${subIndex + 1}`}</td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.buy_item_code || "N/A"}
                            >
                              {row?.buy_item_code || "N/A"}
                            </div>
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.description || "N/A"}
                            >
                              {row?.description || "N/A"}
                            </div>
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {row?.uom || "N/A"}
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {formData?.inputData?.type == "Outward" ||
                            formData?.inputData?.type == "MRB"
                              ? formatNumber(row?.stock_qty) || 0
                              : formData?.inputData?.type == "Scrab"
                              ? formatNumber(row?.mrb_qty) || 0
                              : formatNumber(row?.stock_qty) || 0}
                          </td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "125px",
                            }}
                          >
                            <NumberInput
                              name={
                                formData?.inputData?.type === "Outward"
                                  ? "outward_qty"
                                  : formData?.inputData?.type === "MRB"
                                  ? "mrb_qnty"
                                  : formData?.inputData?.type === "Scrab"
                                  ? "scrab_qty"
                                  : "outward_qty"
                              }
                              onChange={(e) =>
                                handleItemDetailInputChange(
                                  e,
                                  row?.id,
                                  formData?.inputData?.type === "Outward"
                                    ? "outward_qty"
                                    : formData?.inputData?.type === "MRB"
                                    ? "mrb_qnty"
                                    : formData?.inputData?.type === "Scrab"
                                    ? "scrab_qty"
                                    : "outward_qty"
                                )
                              }
                              value={
                                formData?.inputData?.outward_items?.find(
                                  (item) => item.id === row.id
                                )?.[
                                  formData?.inputData.type === "Outward"
                                    ? "outward_qty"
                                    : formData?.inputData.type === "MRB"
                                    ? "mrb_qnty"
                                    : formData?.inputData.type === "Scrab"
                                    ? "scrab_qty"
                                    : ""
                                ] || ""
                              }
                              inputClassName="form-control"
                              labelStyle={{ display: "none" }}
                              placeholder={
                                formData?.inputData?.type === "Outward"
                                  ? "Outward QTY"
                                  : formData?.inputData?.type === "MRB"
                                  ? "MRB QTY"
                                  : formData?.inputData?.type === "Scrab"
                                  ? "Scrap QTY"
                                  : "Quantity"
                              }
                              customError={
                                formErrors?.outward_items &&
                                formErrors?.outward_items[row.id] &&
                                (formData.inputData.type === "Outward"
                                  ? formErrors.outward_items[row.id].outward_qty
                                  : formData.inputData.type === "MRB"
                                  ? formErrors.outward_items[row.id].mrb_qnty
                                  : formData.inputData.type === "Scrab"
                                  ? formErrors.outward_items[row.id].scrab_qty
                                  : "")
                              }
                            />
                          </td>

                          <td
                            onClick={() => handleRemoveItemDetail(group, row)}
                          >
                            <Link className="text-danger">
                              <i className="mdi mdi-trash-can font-size-20"></i>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    {group?.buyItems
                      ?.filter((item) => item.is_show && item.type == 2)
                      ?.map((row, subIndex) => (
                        <tr
                          key={row.unique_id}
                          style={{ borderBottom: "1px solid #ccc" }}
                        >
                          <td>{serialNumber++}</td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.item_code || "N/A"}
                            >
                              {row?.item_code || "N/A"}
                            </div>
                          </td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.description || "N/A"}
                            >
                              {row?.description || "N/A"}
                            </div>
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {row?.uom || "N/A"}
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {formData.inputData.type == "Outward" ||
                            formData.inputData.type == "MRB"
                              ? formatNumber(row?.stock_qty) || 0
                              : formData.inputData.type == "Scrab"
                              ? formatNumber(row?.mrb_qty) || 0
                              : formatNumber(row?.stock_qty) || 0}
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "115px",
                            }}
                          >
                            <NumberInput
                              name={
                                formData.inputData.type === "Outward"
                                  ? "outward_qty"
                                  : formData.inputData.type === "MRB"
                                  ? "mrb_qnty"
                                  : formData.inputData.type === "Scrab"
                                  ? "scrab_qty"
                                  : "outward_qty"
                              }
                              onChange={(e) =>
                                handleItemDetailInputChange(
                                  e,
                                  row?.id,
                                  formData.inputData.type === "Outward"
                                    ? "outward_qty"
                                    : formData.inputData.type === "MRB"
                                    ? "mrb_qnty"
                                    : formData.inputData.type === "Scrab"
                                    ? "scrab_qty"
                                    : "outward_qty"
                                )
                              }
                              value={
                                formData.inputData.outward_items?.find(
                                  (item) => item.id === row.id
                                )?.[
                                  formData.inputData.type === "Outward"
                                    ? "outward_qty"
                                    : formData.inputData.type === "MRB"
                                    ? "mrb_qnty"
                                    : formData.inputData.type === "Scrab"
                                    ? "scrab_qty"
                                    : ""
                                ] || ""
                              }
                              inputClassName="form-control"
                              labelClassName="form-label"
                              placeholder={
                                formData.inputData.type === "Outward"
                                  ? "Outward QTY"
                                  : formData.inputData.type === "MRB"
                                  ? "MRB QTY"
                                  : formData.inputData.type === "Scrab"
                                  ? "Scrap QTY"
                                  : "Outward QTY"
                              }
                              disabled={false}
                              labelStyle={{ display: "none" }}
                              customError={
                                formErrors?.outward_items &&
                                formErrors?.outward_items[row.id] &&
                                (formData.inputData.type === "Outward"
                                  ? formErrors.outward_items[row.id].outward_qty
                                  : formData.inputData.type === "MRB"
                                  ? formErrors.outward_items[row.id].mrb_qnty
                                  : formData.inputData.type === "Scrab"
                                  ? formErrors.outward_items[row.id].scrab_qty
                                  : "")
                              }
                            />
                          </td>

                          <td>
                            <div
                              onClick={() => handleRemoveItemDetail(group, row)}
                            >
                              <Link className="text-danger">
                                <i className="mdi mdi-trash-can font-size-20"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
        <Row className="mt-4">
          <Col md="4">
            <TextAreaInput
              label="Remark"
              name="remark"
              value={formData?.inputData?.remark}
              onChange={onInputChange}
              placeholder="Remark"
              inputClassName="form-control"
              labelClassName="form-label"
              autocomplete={"off"}
            />
          </Col>
        </Row>
      </Row>
    </CustomForm>
  );
};

export default OutwardCreate;
